import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.korslovo');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { RU } from "src/libs/portal/korslovo/i18n";

@Component({
    selector: 'wiz-layout-korslovo',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.korslovo/view.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}`],
})
export class LayoutKorslovoComponent implements OnInit, OnDestroy {
    public ru = RU;
    public isOffline: boolean = false;
    private onlineFn: any;
    private offlineFn: any;

    // 비활동 타이머
    private IDLE_LIMIT = 30 * 60 * 1000;   // 30분(ms)
    private WARN_DURATION = 5 * 60;         // 경고 카운트다운 5분(초)
    private idleTimer: any = null;
    private countdownTimer: any = null;
    private activityFn: any;
    public showIdleWarning: boolean = false;
    public idleCountdown: number = 0;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (!this.service.auth.allow('/access')) return;

        this.isOffline = !navigator.onLine;
        this.onlineFn = async () => { this.isOffline = false; await this.service.render(); };
        this.offlineFn = async () => { this.isOffline = true; await this.service.render(); };
        window.addEventListener('online', this.onlineFn);
        window.addEventListener('offline', this.offlineFn);

        // 비활동 감지 시작
        this.activityFn = () => this.resetIdleTimer();
        ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll'].forEach(evt => {
            window.addEventListener(evt, this.activityFn, { passive: true });
        });
        this.resetIdleTimer();
    }

    ngOnDestroy() {
        if (this.onlineFn) window.removeEventListener('online', this.onlineFn);
        if (this.offlineFn) window.removeEventListener('offline', this.offlineFn);
        if (this.activityFn) {
            ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll'].forEach(evt => {
                window.removeEventListener(evt, this.activityFn);
            });
        }
        this.clearTimers();
    }

    private resetIdleTimer() {
        if (this.showIdleWarning) return; // 경고 중에는 리셋 안 함
        if (this.idleTimer) clearTimeout(this.idleTimer);
        this.idleTimer = setTimeout(() => this.startWarning(), this.IDLE_LIMIT);
    }

    private async startWarning() {
        this.showIdleWarning = true;
        this.idleCountdown = this.WARN_DURATION;
        await this.service.render();
        this.countdownTimer = setInterval(async () => {
            this.idleCountdown--;
            if (this.idleCountdown <= 0) {
                this.clearTimers();
                this.doLogout();
                return;
            }
            await this.service.render();
        }, 1000);
    }

    public async dismissWarning() {
        this.showIdleWarning = false;
        this.clearTimers();
        this.resetIdleTimer();
        await this.service.render();
    }

    private clearTimers() {
        if (this.idleTimer) { clearTimeout(this.idleTimer); this.idleTimer = null; }
        if (this.countdownTimer) { clearInterval(this.countdownTimer); this.countdownTimer = null; }
    }

    public doLogout() {
        window.location.href = '/auth/logout';
    }

    public get idleMinutes(): number {
        return Math.floor(this.idleCountdown / 60);
    }

    public get idleSeconds(): number {
        return this.idleCountdown % 60;
    }

    public isNavActive(link: string) {
        const path = location.pathname;
        if (link === '/category') {
            return path.indexOf('/category') === 0 || path.indexOf('/learn') === 0 || path.indexOf('/quiz') === 0;
        }
        return path.indexOf(link) === 0;
    }

    public navLinkClass(link: string) {
        if (this.isNavActive(link)) {
            return 'text-emerald-600 border-b-2 border-emerald-600 font-semibold';
        }
        return 'text-zinc-500 hover:text-zinc-900 border-b-2 border-transparent';
    }
}

export default LayoutKorslovoComponent;